import {
  Route,
  Routes,
  Navigate,
} from 'react-router';

import {
  NavigationTabs,
  ContentWrapper,
  PaymentsDetails,
  PaymentsInvoices,
} from 'web-components';

const tabs = [
  {
    to: '/account/transactions',
    name: 'Transaction History',
  },
  {
    to: '/account/details',
    name: 'My Account',
  },
];

const AccountPage = () => {
  return (
    <ContentWrapper
      header={(
        <NavigationTabs
          tabs={tabs}
        />
      )}
    >
      <Routes>
        <Route
          index
          element={<Navigate to="transactions" replace />}
        />
        <Route
          path="transactions"
          Component={PaymentsInvoices}
        />
        <Route
          path="details"
          Component={PaymentsDetails}
        />
      </Routes>
    </ContentWrapper>
  );
};

export default AccountPage;
